import { render, staticRenderFns } from "./AmazonPayOnetime.vue?vue&type=template&id=9590bb64&scoped=true&"
import script from "./AmazonPayOnetime.vue?vue&type=script&lang=ts&"
export * from "./AmazonPayOnetime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9590bb64",
  null
  
)

export default component.exports